export default "/images/a61dfa2c1e57117e186e6ed39fe6c272.avif";